import * as FC from "@fluentui/react-components";
import * as IC from "@fluentui/react-icons";
import { useCommonStyles } from "../../../style_util";
import { SimpleGrid, useSimpleGrid } from "../../../components/simple_grid";
import { useDrawer } from "../../../components/use_drawer";
import { bindInputValue, useInfo } from "../../../form_utils";
import { DeleteButton } from "../../../components/delete_button";
import { useContext } from "react";
import { Context } from "../../../context";
import { apiClient } from "../../../services/api";
import { describeWriteError } from "../../../services/write_errors";
import { ManuTurbineDropdown } from "../../../services/manu_turbine_service";
import {
    ModelTurbineDef,
    listModelTurbine,
} from "../../../services/model_turbine_service";
import { getCurrentFieldId } from "../../../workspace";

const ModelTurbineForm = ({ item, onChange }) => {
    const { user } = useContext(Context);
    const { info, setInfo, updateInfo } = useInfo();
    const v = bindInputValue(item, info, setInfo);
    // See manu_turbine.js: without ?tenantId= these writes can only ever return 400.
    const tenantId = user?.tenantId;

    const onDelete = async () => {
        try {
            await apiClient.deleteModelTurbine(item.id, tenantId);
            onChange();
        } catch (error) {
            console.error("Failed to delete turbine model:", error);
            alert("删除失败: " + describeWriteError(error));
        }
    };
    const onSave = async () => {
        try {
        if (item) {
            if (info.power) {
                info.power = parseFloat(info.power);
            }
            await apiClient.updateModelTurbine(item.id, info, tenantId);
            onChange();
        } else {
            const fieldId = getCurrentFieldId();
            // Extract numeric ID from SurrealDB record format (e.g., "field_item:2" -> 2)
            const numericFieldId = typeof fieldId === 'string' && fieldId.includes(':') 
                ? parseInt(fieldId.split(':')[1]) 
                : fieldId;
            
            // Extract numeric manufacturer ID
            const manuId = typeof info.manu === 'string' && info.manu.includes(':')
                ? parseInt(info.manu.split(':')[1])
                : info.manu;

            let _info = { 
                Seq: info.seq || '',
                Power: info.power ? parseFloat(info.power) : 0,
                Description: info.description || '',
                ManuId: manuId,
                FieldItemId: numericFieldId
            };
            console.log('Creating model_turbine with data:', _info);
            await apiClient.createModelTurbine(_info, tenantId);
            onChange();
        }
        } catch (error) {
            console.error("Failed to save turbine model:", error);
            alert("保存失败: " + describeWriteError(error));
        }
    };

    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.form}>
            <FC.Input contentBefore={"编号"} {...v("seq")} />
            <FC.Label>选择厂商</FC.Label>
            <ManuTurbineDropdown
                defaultValue={item?.manu?.name}
                onOptionSelect={(evt, data) => {
                    updateInfo({ manu: data.optionValue });
                }}
            />
            <FC.Input
                contentBefore={"功率(MW)"}
                type="number"
                {...v("power")}
            />
            <FC.Label>备注</FC.Label>
            <FC.Textarea {...v("description")} />
            <FC.Divider />
            {item && <DeleteButton onClick={onDelete} />}
            <FC.Button onClick={onSave} disabled={!info} appearance="primary">
                {(item && "保存") || "创建"}
            </FC.Button>
        </div>
    );
};
export const ModelTurbineManagement = () => {
    const { openDrawer, closeDrawer, drawer } = useDrawer();

    const { items, refresh, SearchInput } = useSimpleGrid({
        listItems: listModelTurbine,
        placeholder: "按厂商、功率搜索...",
    });

    const onFormChange = () => {
        refresh();
        closeDrawer();
    };
    const onNewModelTurbine = () => {
        openDrawer({
            header: "创建风机型号",
            body: <ModelTurbineForm item={null} onChange={onFormChange} />,
        });
    };
    const columns = [
        ModelTurbineDef.createTableColumn("seq"),
        ModelTurbineDef.createTableColumn("manu"),
        ModelTurbineDef.createTableColumn("power"),
        ModelTurbineDef.createTableColumn("description"),
        ModelTurbineDef.createOpsColumn({
            renderCell: (item) => {
                const onClick = () => {
                    openDrawer({
                        header: "风机型号详情",
                        body: (
                            <ModelTurbineForm
                                item={item}
                                onChange={onFormChange}
                            />
                        ),
                    });
                };
                return (
                    <FC.TableCellLayout>
                        <FC.Button
                            appearance="subtle"
                            icon={<IC.MoreCircleFilled />}
                            onClick={onClick}
                        />
                    </FC.TableCellLayout>
                );
            },
        }),
    ];
    const commonStyles = useCommonStyles();
    return (
        <div className={commonStyles.root}>
            <div className={commonStyles.row}>
                <FC.Label>快速检索</FC.Label>
                <SearchInput />
                <FC.Button appearance="primary" onClick={onNewModelTurbine}>
                    创建风机型号
                </FC.Button>
            </div>
            <SimpleGrid items={items} columns={columns} />
            {drawer}
        </div>
    );
};
